// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__n1PXK","shimmer":"styles_shimmer__JWpE0"};